export default {"src":"/uk/_next/static/media/circle-border.0a7d46c9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};